var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 662 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 30C0.5 13.7076 13.7076 0.5 30 0.5H632C648.292 0.5 661.5 13.7076 661.5 30V99.0224C661.5 115.315 648.292 128.522 632 128.522H603.942C595.888 128.522 588.162 131.708 582.448 137.383L559.401 160.274L540.021 138.661C534.235 132.209 525.979 128.522 517.313 128.522H30C13.7076 128.522 0.5 115.315 0.5 99.0224V30Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.d548abaa6d234e4f7f4cfc94b69a69ce.svg";
export { ForwardRef as ReactComponent };